import React from "react";
import { PredictionMarketTrendingWidget } from "@/components/PredictionMarketTrendingWidget";
import { useRouter } from "next/router";
import Head from "next/head";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSideProps } from "next";

const EmbedTrendingEventsPage = () => {
  const router = useRouter();
  const { theme, width } = router.query;

  return (
    <div className="fixed inset-0 bg-transparent flex justify-center items-stretch overflow-hidden p-4 custom-scrollbar overflow-y-auto">
      <Head>
        <title>Trending Prediction Events Widget</title>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0" />
        <style>{`
          body {
            background: transparent !important;
            margin: 0;
            padding: 0;
          }
          /* Custom scrollbar for small embedded view */
          .custom-scrollbar::-webkit-scrollbar {
            width: 6px;
          }
          .custom-scrollbar::-webkit-scrollbar-track {
            background: rgba(255, 255, 255, 0.02);
          }
          .custom-scrollbar::-webkit-scrollbar-thumb {
            background: rgba(255, 255, 255, 0.1);
            border-radius: 10px;
          }
        `}</style>
      </Head>
      <div className="w-full h-full max-w-6xl mx-auto">
        <PredictionMarketTrendingWidget 
          width={width ? String(width) : "100%"} 
          theme={(theme as any) || "dark"}
        />
      </div>
    </div>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || "en", [
        "broker-page", 
        "common-page",
        "layout-page",
        "build-page",
        "marketplace-page"
      ])),
    },
  };
};

export default EmbedTrendingEventsPage;
